import { Routes } from "@angular/router";
import { UnauthorizedComponent } from "../modules/authorization/components/unauthorized/unauthorized.component";
import { WebAuthorizedLayoutComponent } from "../modules/common/web-authorized-layout/web-authorized-layout.component";
import { ApplyHomeComponent } from "../modules/pages/apply/components/apply-home/apply-home.component";
import { ApplyComponent } from "../modules/pages/apply/components/apply/apply.component";
import { IdCardComponent } from "../modules/pages/apply/components/id-card/id-card.component";
import { AttendanceDetailsComponent } from "../modules/pages/attendance/components/attendance-details/attendance-details.component";
import { BusPassApplicationComponent } from "../modules/pages/bus-pass-application/components/bus-pass-application/bus-pass-application.component";
import { CalendarComponent } from "../modules/pages/calendar/components/calendar/calendar.component";
import { MonthComponent } from "../modules/pages/calendar/components/month/month.component";
import { ScheduleComponent } from "../modules/pages/calendar/components/schedule/schedule.component";
import { WeekComponent } from "../modules/pages/calendar/components/week/week.component";
import { DashboardComponent } from "../modules/pages/dashboard/components/dashboard/dashboard.component";
import { ExamsComponent } from "../modules/pages/exams/components/exams/exams.component";
import { FeeDetailsComponent } from "../modules/pages/fees/components/fee-details/fee-details.component";
import { FeesComponent } from "../modules/pages/fees/components/fees/fees.component";
import { AlbumsComponent } from "../modules/pages/gallery/components/albums/albums.component";
import { HomeworksComponent } from "../modules/pages/homeworks/components/homeworks/homeworks.component";
import { LessonNotesComponent } from "../modules/pages/lesson-notes/components/lesson-notes/lesson-notes.component";
import { MessagesComponent } from "../modules/pages/messages/components/messages/messages.component";
import { NoticesComponent } from "../modules/pages/notices/components/notices/notices.component";
import { EditPickupWrapperComponent } from '../modules/pages/profile/components/edit-pickup-wrapper/edit-pickup-wrapper.component';
import { EditEmgContactWrapperComponent } from '../modules/pages/profile/components/edit-emg-contact-wrapper/edit-emg-contact-wrapper.component';
import { EditProfileComponent } from "../modules/pages/profile/components/edit-profile/edit-profile.component";
import { ProfileComponent } from "../modules/pages/profile/components/profile/profile.component";
import { StudentEditProfileComponent } from "../modules/pages/profile/components/student-edit-profile/student-edit-profile.component";
import { HistoryDashboardComponent } from "../modules/pages/student-history/components/history-dashboard/history-dashboard.component";
import { TeachersCommentsComponent } from "../modules/pages/teachers-comments/components/teachers-comments/teachers-comments.component";
import { WeeklyTimetableComponent } from "../modules/pages/timetable/components/weekly-timetable/weekly-timetable.component";
import { SubmitHomeworkComponent } from '../modules/pages/homeworks/components/submit-homework/submit-homework.component';
import { PreviousQuestionPaperComponent } from '../modules/pages/previous-question-paper/components/previous-question-paper/previous-question-paper.component';
import { OnlineExamStartComponent } from '../modules/pages/online-exam/components/online-exam-start/online-exam-start.component';
import { AttemptOnlineExamComponent } from '../modules/pages/online-exam/components/attempt-online-exam/attempt-online-exam.component';
import { OnlineExamSuccessComponent } from '../modules/pages/online-exam/components/online-exam-success/online-exam-success.component';
import { OnlineMeetingLobbyComponent } from "../modules/pages/online-meetings/components/online-meeting-lobby/online-meeting-lobby.component";
import { OnlineMeetingsComponent } from "../modules/pages/online-meetings/components/online-meetings/online-meetings.component";

export const webAppRoutes: Routes = [
    { path: '', redirectTo: '/pages/dashboard', pathMatch: 'full' },
    {
        path: 'pages', component: WebAuthorizedLayoutComponent, children: [
            { path: '', redirectTo: '/pages/dashboard', pathMatch: 'full' },
            { path: 'dashboard', component: DashboardComponent },
            {
                path: 'calendar', component: CalendarComponent, children: [
                    { path: '', redirectTo: 'month', pathMatch: 'full' },
                    { path: 'month/:date', component: MonthComponent },
                    { path: 'month', component: MonthComponent },
                    { path: 'week/:date', component: WeekComponent },
                    { path: 'week', component: WeekComponent },
                    { path: 'schedule', component: ScheduleComponent }
                ]
            },
            { path: 'messages', component: MessagesComponent },
            { path: 'messages/:id', component: MessagesComponent },
            { path: 'notices', component: NoticesComponent },
            { path: 'notices/:id', component: NoticesComponent },
            { path: 'teachers-comments', component: TeachersCommentsComponent },
            { path: 'teachers-comments/:id', component: TeachersCommentsComponent },
            { path: 'fees', component: FeesComponent },
            { path: 'fee-details', component: FeeDetailsComponent },
            { path: 'homeworks', component: HomeworksComponent },
            { path: 'submit-homework/:homeworkId', component: SubmitHomeworkComponent},
            { path: 'lesson-notes', component: LessonNotesComponent },
            { path: 'lesson-notes/:id', component: LessonNotesComponent },
            { path: 'exams', component: ExamsComponent },
            { path: 'exams/:id', component: ExamsComponent },
            {
                path: 'apply', component: ApplyComponent, children: [
                    { path: 'id-card', component: IdCardComponent }
                ]
            },
            { path: 'apply', component: ApplyHomeComponent },
            { path: 'my-account/:option', component: ProfileComponent },
            { path: 'my-account-edit', component: EditProfileComponent },
            { path: 'student-account-edit', component: StudentEditProfileComponent },
            { path: 'edit-pickup-assistant', component: EditPickupWrapperComponent },
            { path: 'edit-emergency-contact', component: EditEmgContactWrapperComponent },
            { path: 'timetable', component: WeeklyTimetableComponent },
            { path: 'attendance', component: AttendanceDetailsComponent },
            { path: 'studenthistory', component: HistoryDashboardComponent },
            { path: 'gallery', component: AlbumsComponent },
            { path: 'unauthorized', component: UnauthorizedComponent },
            { path: 'bus-pass-application', component: BusPassApplicationComponent },
            { path: 'previous-question-papers', component: PreviousQuestionPaperComponent },
            { path: 'previous-question-papers/:id', component: PreviousQuestionPaperComponent },
            { path: 'online-meetings', component: OnlineMeetingsComponent }
        ]
    },
    {
        path: 'start-online-exam/:id', component: OnlineExamStartComponent
    },
    {
        path: 'online-exam/:id/attempt/:attemptId', component: AttemptOnlineExamComponent
    },
    {
        path: 'online-exam-success', component: OnlineExamSuccessComponent
    },
    {
        path: 'online-meeting-lobby', component: OnlineMeetingLobbyComponent
    }
];